module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TasksUse2-325868481030e82467e7e48798fd372f.jpg";